<template>
  <div class="main-container">
    <div class="ark-carousel">
      <div class="ark-carousel__left">
        <main-menu></main-menu>
      </div>
      <div class="ark-carousel__right">
        <h2 class="main-title">Arkadium.com Carousel Data control</h2>
        <div class="column-control__wrap column-control__wrap--ark-carousel">
          <div class="column-control__left column-control__left--ark-carousel">
            <!-- instances list -->
            <v-select
              outlined
              hide-selected
              persistent-hint
              dense
              auto-select-first
              v-model="selectedInstance"
              :items="cmbInstances"
              return-object
              label="Select an instance"
              v-on:change="onSelectedInstanceChanged"
            />
          </div>

          <div
            v-if="instanceSchema && instanceData && instanceData.items"
            class="column-control__right column-control__right--ark-carousel"
          >
            <v-card style="padding: 5px; marging: 5px"
              v-for="(item, index) in instanceData.items"
              :key="`v-card-${index}`"
            >
              <v-card-title> Carousel item {{ index }} </v-card-title>
                <v-card style="padding: 5px; margin: 5px" v-if="instanceData.filesMetas && instanceData.filesMetas[index]">
                  <v-card-title>Uploaded files</v-card-title>
                  <v-card-text
                    v-for="file in instanceData.filesMetas[index]"
                    :key="`${index}_file_${file.propertyName}`"
                  >
                    <a
                      target="_blank"
                      :href="`${instanceData.storageBaseUrl}/${file.path}`"
                      >{{ file.propertyName }}</a
                    >
                  </v-card-text>
                </v-card>
              <v-jsf
                v-model="instanceData.items[index]"
                :schema="instanceSchema"
                :options="options"
              />
              <v-card-actions>
                <v-btn class="ma-1" color="error" v-on:click="deleteItem(index)"
                  >Delete</v-btn
                >
              </v-card-actions>
            </v-card>
            <v-row v-if="instanceData" class="py-5" dense no-gutters>
              <v-btn block color="primary" v-on:click="addItem()"
                >Add item</v-btn
              >
            </v-row>
            <v-row
              class="py-5"
              v-if="selectedInstance && isInstancesLoading === false"
              dense
              no-gutters
            >
              <v-btn block color="primary" v-on:click="saveData()"
                >Save data</v-btn
              >
            </v-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MainMenu from '../../MainMenu/MainMenu.vue';
import config from '../../../config';

export default {
    name: 'ArkCarousel',
    components: { MainMenu },
    data() {
        return {
            isInstancesLoading: false,

            cmbInstances: null,
            selectedInstance: null,
            instanceSchema: null,
            instanceData: null,

            options: {
                filesAsDataUrl: false
            }
        };
    },
    created: function() {
        this.getInstances();
    },
    methods: {
        deleteItem: function(index) {
            this.instanceData.items = this.instanceData.items.filter((item, idx) => idx !== index);
        },
        addItem: function() {
            this.instanceData.items.push({});
        },
        saveData: function() {
            let url = `${config.apiUrl}/ark_home_carousel/save-file-data`;
            let formModel = {
                instanceName: this.selectedInstance.value,
                data: this.instanceData
            };
            this.$http.post(url, formModel).then(
                async (_) => {
                    await this.loadInstanceData();
                },
                (error) => {
                    console.log(error);
                }
            );
        },
        _fetchFromApi: async function(url) {
            let result;
            await this.$http.get(url).then(
                (response) => {
                    if (response.body) {
                        result = response.body;
                    }
                },
                (error) => {
                    console.log(error);
                }
            );
            return result;
        },
        loadInstanceSchema: async function() {
            this.instanceData = null;
            let url = `${config.apiUrl}/ark_home_carousel/get-instance-schema?instanceName=${
                this.selectedInstance.value
            }`;
            var data = await this._fetchFromApi(url);
            if (data && data.schema && data.schema.carouselItem) {
                this.instanceSchema = data.schema.carouselItem;
            } else {
                this.instanceSchema = {};
            }
        },
        loadInstanceData: async function() {
            let url = `${config.apiUrl}/ark_home_carousel/get-file-data?instanceName=${this.selectedInstance.value}`;
            this.instanceData = await this._fetchFromApi(url);
        },
        loadInstanceSchemaAndData: async function() {
            if (!this.selectedInstance) {
                return 0;
            }
            this.instanceData = null;
            await this.loadInstanceSchema();
            await this.loadInstanceData();
        },
        onSelectedInstanceChanged: async function(instance) {
            this.selectedInstance = instance;
            await this.loadInstanceSchemaAndData();
        },
        getInstances: async function() {
            this.isInstancesLoading = true;
            let url = `${config.apiUrl}/ark_home_carousel/get-instances-names`;
            await this.$http
                .get(url)
                .then(
                    (response) => {
                        let data = response.body;

                        this.cmbInstances = data.map((key) => {
                            return { text: key, value: key };
                        });
                    },
                    (error) => {
                        console.log(error);
                    }
                )
                .then(() => {
                    this.isInstancesLoading = false;
                });
        }
    }
};
</script>

<style scoped src="./ArkCarousel.scss" lang="scss">
</style>
